import Id from './Id';
import Driver from './Driver';
import Routes from './Routes';
import StartDate from './StartDate';
import ShopVisitCount from './ShopVisitCount';
import Created from './Created';
import Updated from './Updated';


export const labels = {
  Id: 'Id',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  Driver: 'Képviselő',
  Routes: 'Megállók',
  StartDate: 'Kezdés időpontja',
  ShopVisitCount: 'Bolt látogatások',
};

export const allColumns = [{
  value: 'Routes',
  fixed: true,
}, {
  value: 'Id',
  fixed: true,
}, {
  value: 'Driver',
}, {
  value: 'StartDate',
}, {
  value: 'ShopVisitCount',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}];

export const defaultColumns = [{
  value: 'Routes',
  fixed: true,
}, {
  value: 'Id',
  fixed: true,
}, {
  value: 'Driver',
}, {
  value: 'StartDate',
}, {
  value: 'ShopVisitCount',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'descending'
};

export default {
  Id,
  Created,
  Updated,
  Driver,
  Routes,
  StartDate,
  ShopVisitCount,
};
